import { Pipe, PipeTransform } from '@angular/core';
import { SexoBeneficiario } from 'src/app/core/models/beneficiario/SexoBeneficiario';

@Pipe({
  name: 'sexoBeneficiario',
})
export class SexoBeneficiarioPipe implements PipeTransform {
  transform(value: SexoBeneficiario): unknown {
    switch (value) {
      case SexoBeneficiario.Masculino:
        return 'Masculino';
      default:
        return 'Feminino';
    }
  }
}
